import { render, staticRenderFns } from "./LeadSecondModal.vue?vue&type=template&id=08d85233&scoped=true&"
import script from "./LeadSecondModal.vue?vue&type=script&lang=js&"
export * from "./LeadSecondModal.vue?vue&type=script&lang=js&"
import style0 from "./LeadSecondModal.vue?vue&type=style&index=0&id=08d85233&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d85233",
  null
  
)

export default component.exports